import { Button } from "reactstrap";
import SettingsGroupCard from "elements/SettingsGroupCard";

const EditActionHomeSection = ({
  setSection,
  noAdditional,
  handleDeleteAction,
}) => {
  const setPage = (newSection) => () => setSection(newSection);

  return (
    <div className="h-100 d-flex flex-column justify-content-between">
      <div>
        <SettingsGroupCard
          title="Action Information"
          description="Modify basic information about the action, such as name and
                      description."
          onClick={setPage("Info")}
        />
        <SettingsGroupCard
          title={`Action Configuration`}
          description={`Modify settings specific to this action type.`}
          onClick={setPage("ActionConfig")}
        />
        {!noAdditional && (
          <SettingsGroupCard
            title="Additional Settings"
            description="Additional configuration for this action type."
            onClick={setPage("Additional")}
          />
        )}
      </div>
      <Button
        outline
        color="danger"
        className="w-100 mb-5"
        onClick={handleDeleteAction}
      >
        Delete This Action
      </Button>
    </div>
  );
};

export default EditActionHomeSection;
